export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

interface Props {
    value?: string[]
    innerValue?: string[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {value: ['$0'], innerValue: []};
    }

    onShow() {
        console.log('show');
    }
}